import { useEffect, useState } from "react";

interface NetworkStatus {
  isOnline: boolean;
  connectionType: string;
  isSlow: boolean;
}

export const useNetworkStatus = (): NetworkStatus => {

  const getConnection = () =>
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;

  const getStatus = (): NetworkStatus => {
    const connection = getConnection();
    const type = connection?.effectiveType || "unknown";

    return {
      isOnline: navigator.onLine,
      connectionType: type,
      isSlow: type === "slow-2g" || type === "2g"
    };
  };

  const [status, setStatus] = useState<NetworkStatus>(getStatus);

  useEffect(() => {
    const updateNetworkStatus = () => {
      setStatus(getStatus());
    };

    const connection = getConnection();

    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);
    connection?.addEventListener("change", updateNetworkStatus);

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
      connection?.removeEventListener("change", updateNetworkStatus);
    };
  }, []);

  return status;
};